import React from 'react';
import { PricingVersion } from '../../GlobalJobMatchingVersioning/types/versions'
import { Badge } from "@mantine/core";
import { IconCircleFilled } from '@tabler/icons-react';

type StatusIconProps = {
    pricingVersion: PricingVersion | undefined
    size?: string
}

const STATUS_MAP = {
    running: {label: 'In progress', badgeColor: 'newBlue', iconColor: 'newBlue', fontColor: '#0d48a3' },
    success:  {label: 'Success', badgeColor: 'green', iconColor: 'green', fontColor: '#037847' },
    failed: {label: 'Failed', badgeColor: 'red', iconColor: 'red', fontColor: 'red' },
}

export const StatusIcon: React.FC<StatusIconProps> = ({ pricingVersion, size = 'lg' }) => {
    const runStatus = pricingVersion?.runStatus ?? 'running';
    const { label, badgeColor, iconColor, fontColor } = STATUS_MAP[runStatus];
    const colorIcon = <IconCircleFilled color={iconColor} style={{ height: 6, width: 6}} />;

    return (
      <Badge
        size={size}
        color={badgeColor}
        variant='light'
        leftSection={colorIcon}
        styles={{
          root: {
            radius: 16
          },
          label: {
            textTransform: 'capitalize',
            fontWeight: 500,
            fontSize: 12,
            color: fontColor,
            marginLeft: 5
          }}}
      >
        {label}
      </Badge>
    );
};
